(function () {
  const dataEl = document.getElementById('almam-dl-data');
  if (!dataEl) return;

  let page;
  try {
    page = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  const currency = page.currency;

  // almam_source deosebeste in GTM evenimentele temei de gtag('event') ale aplicatiei Google, care scrie in acelasi dataLayer.
  function pushEvent(data) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ...data, almam_source: 'theme' });
    window.dataLayer.push({ almam_source: undefined });
  }

  function push(event, ecommerce) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    pushEvent({ event, ecommerce });
  }

  function value(items) {
    return Math.round(items.reduce((sum, i) => sum + i.price * i.quantity, 0) * 100) / 100;
  }

  // fbq vine din pixelul aplicatiei Facebook, incarcat asincron; un track trimis inainte de init se pierde.
  function whenMetaReady(callback, triesLeft = 40) {
    const fbq = window.fbq;
    if (typeof fbq === 'function' && typeof fbq.getState === 'function' && fbq.getState().pixels.length) {
      callback(fbq);
    } else if (triesLeft > 0) {
      setTimeout(() => whenMetaReady(callback, triesLeft - 1), 250);
    }
  }

  if (page.product) {
    push('view_item', { currency, value: page.product.price, items: [page.product] });
  }

  if (page.list && page.list.items.length) {
    const items = page.list.items.map((i) => ({ ...i, item_list_id: page.list.id, item_list_name: page.list.name }));
    push('view_item_list', { item_list_id: page.list.id, item_list_name: page.list.name, items });

    if (page.pageType === 'collection') {
      whenMetaReady((fbq) => fbq('trackCustom', 'ViewCategory', {
        content_category: page.list.name,
        content_ids: items.map((i) => i.item_id),
        content_type: 'product_group',
      }));
    }

    document.addEventListener('click', (event) => {
      const link = event.target.closest('a[href*="/products/"]');
      if (!link) return;
      const handle = decodeURIComponent((link.pathname.split('/products/')[1] || '').split('/')[0]);
      const item = items[page.list.handles.indexOf(handle)];
      if (!item) return;
      push('select_item', { item_list_id: page.list.id, item_list_name: page.list.name, items: [item] });
    }, { capture: true });
  }

  if (page.searchTerm) {
    pushEvent({ event: 'search', search_term: page.searchTerm });
  }

  if (page.cart && page.cart.items.length) {
    push('view_cart', { currency, value: page.cart.value, items: page.cart.items });
  }

  function requestedQuantities(body) {
    const result = {};
    if (body instanceof FormData) {
      const id = body.get('id');
      if (id) result[String(id)] = parseInt(body.get('quantity'), 10) || 1;
      return result;
    }
    if (typeof body === 'string') {
      try {
        const json = JSON.parse(body);
        (json.items || [json]).forEach((i) => { if (i.id) result[String(i.id)] = parseInt(i.quantity, 10) || 1; });
      } catch (e) {
        new URLSearchParams(body).forEach((v, k) => { if (k === 'id') result[v] = 1; });
      }
    }
    return result;
  }

  function toItem(line, quantity) {
    return {
      item_id: line.sku || String(line.product_id),
      item_name: line.product_title,
      item_variant: line.variant_title || '',
      item_brand: line.vendor,
      price: (line.final_price != null ? line.final_price : line.price) / 100,
      quantity,
    };
  }

  const originalFetch = window.fetch;
  window.fetch = function (input, init) {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const isAdd = /\/cart\/add(\.js)?(\?|$)/.test(url);
    const promise = originalFetch.apply(this, arguments);
    if (!isAdd) return promise;

    const quantities = requestedQuantities(init && init.body);
    promise.then((response) => {
      if (!response.ok) return;
      response.clone().json().then((data) => {
        const lines = data.items || [data];
        const items = lines
          .filter((line) => line && line.variant_id)
          .map((line) => toItem(line, quantities[String(line.variant_id)] || quantities[String(line.id)] || 1));
        if (items.length) push('add_to_cart', { currency, value: value(items), items });
      }).catch(() => {});
    }).catch(() => {});
    return promise;
  };
})();
